import { mutatorAction } from 'satcheljs';
import { getStore } from '../store/store';
import { MailRibbonConfigStore } from 'owa-mail-ribbon-store-shared-types';
import ContextualRibbonTab from 'owa-mail-ribbon-store-shared-types/lib/types/contextualRibbonTab';

export default mutatorAction(
    'setToggleableTabs',
    (toggleTab: ContextualRibbonTab, toggleOn: boolean) => {
        const store: MailRibbonConfigStore = getStore();
        const index: number = store.contextualTabs.indexOf(toggleTab);
        if (toggleOn && index == -1) {
            store.contextualTabs.push(toggleTab);
        }

        if (!toggleOn && index > -1) {
            store.contextualTabs.splice(index, 1);
        }
    }
);
